import { render, staticRenderFns } from "./checkout.vue?vue&type=template&id=0ddeb1e4&scoped=true"
import script from "./checkout.vue?vue&type=script&lang=js"
export * from "./checkout.vue?vue&type=script&lang=js"
import style0 from "./checkout.vue?vue&type=style&index=0&id=0ddeb1e4&prod&lang=scss"
import style1 from "./checkout.vue?vue&type=style&index=1&id=0ddeb1e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddeb1e4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NumberPad: require('/home/ubuntu/complete-nuxt-js/components/number-pad.vue').default,Denominations: require('/home/ubuntu/complete-nuxt-js/components/denominations.vue').default,CustomerModal: require('/home/ubuntu/complete-nuxt-js/components/customer-modal.vue').default,CustomerOtpModal: require('/home/ubuntu/complete-nuxt-js/components/customer-otp-modal.vue').default,TablesModal: require('/home/ubuntu/complete-nuxt-js/components/tables-modal.vue').default,TipModal: require('/home/ubuntu/complete-nuxt-js/components/tip-modal.vue').default,ForeignCurrencyModal: require('/home/ubuntu/complete-nuxt-js/components/foreign-currency-modal.vue').default,LocationSearchBox: require('/home/ubuntu/complete-nuxt-js/components/location-search-box.vue').default,GoogleMap: require('/home/ubuntu/complete-nuxt-js/components/google-map.vue').default})
